/* global SideDrawer */

if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();

      this.content = this.querySelector('.js-product-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.fetch = null;
      this.fetchedUrls = [];
      this.productEl = null;
      this.productUrl = null;

      this.fbVipLastFocusedElement = null;
      this.fbCartButtonObserver = null;
      this.fbInventoryRequestId = 0;
      this.fbVariantDataset = null;
      this.fbSizeSelected = false;
      this.fbSizeChartSelectionPending = false;

      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);
      this.vipPopupClickHandler = this.handleVipPopupClick.bind(this);
      this.vipPopupKeydownHandler = this.handleVipPopupKeydown.bind(this);
      this.couponCopyClickHandler = this.handleCouponCopyClick.bind(this);
      this.drawerClickHandler = this.handleDrawerClick.bind(this);
      this.drawerChangeHandler = this.handleDrawerChange.bind(this);
      this.drawerSubmitHandler = this.handleDrawerSubmit.bind(this);
      this.drawerToggleHandler = this.handleDrawerToggle.bind(this);
      this.sizeChartSelectHandler = this.handleSizeChartSelect.bind(this);

      document.addEventListener('click', this.documentClickHandler);
      document.addEventListener('click', this.vipPopupClickHandler);
      document.addEventListener('keydown', this.vipPopupKeydownHandler);
      document.addEventListener('click', this.couponCopyClickHandler);

      this.addEventListener('click', this.drawerClickHandler, true);
      this.addEventListener('change', this.drawerChangeHandler);
      this.addEventListener('submit', this.drawerSubmitHandler, true);
      this.addEventListener('toggle', this.drawerToggleHandler, true);
      this.addEventListener('fb:size:select', this.sizeChartSelectHandler);
      this.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      this.openCartDrawerLinks.forEach((link) => {
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-quick-add').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });

              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });

          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }

      this.injectCartButtonStyles();
      this.ensureVipPopup();
      this.bindKlaviyoPopupClose();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.removeEventListener('click', this.vipPopupClickHandler);
      document.removeEventListener('keydown', this.vipPopupKeydownHandler);
      document.removeEventListener('click', this.couponCopyClickHandler);

      this.removeEventListener('click', this.drawerClickHandler, true);
      this.removeEventListener('change', this.drawerChangeHandler);
      this.removeEventListener('submit', this.drawerSubmitHandler, true);
      this.removeEventListener('toggle', this.drawerToggleHandler, true);
      this.removeEventListener('fb:size:select', this.sizeChartSelectHandler);

      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });

      if (this.observer) this.observer.disconnect();
      if (this.fbCartButtonObserver) this.fbCartButtonObserver.disconnect();

      this.cleanupFbSizeCharts();
    }

    /* ==========================================================
       TABEL DE MĂRIMI – INIȚIALIZARE ÎN QUICK ADD
       ========================================================== */

    cleanupFbSizeCharts() {
      if (!this.content) return;

      const modalIds = new Set();

      this.content.querySelectorAll('[data-fbsc-root][id]').forEach((root) => {
        modalIds.add(`${root.id}-modal`);
      });

      modalIds.forEach((modalId) => {
        const modal = document.getElementById(modalId);
        if (modal) modal.remove();
      });

      document.body.classList.remove('fbsc-lock');
    }

    initializeFbSizeCharts() {
      if (!this.content) return;

      const roots = Array.from(
        this.content.querySelectorAll('[data-fbsc-root]')
      );

      roots.forEach((root) => {
        if (!root.id || root.dataset.fbscInit === 'true') return;

        /*
         * Az fb-size-chart snippet inicializáló <script> eleme nem a
         * [data-fbsc-root] belsejében van, hanem ugyanabban a
         * .product-options blokkban, közvetlenül a mérettábla markup után.
         * A Quick Add innerHTML-lel másolja be ezt a blokkot, ezért az
         * inline script nem fut le automatikusan – nekünk kell egyszer
         * végrehajtani.
         */
        const chartScope = root.closest('.product-options') || this.content;
        const sourceScript = Array.from(
          chartScope.querySelectorAll('script:not([type="application/json"])')
        ).find((script) => {
          const code = String(script.textContent || '');
          return code.includes('fbscInit') && code.includes(root.id);
        });

        if (!sourceScript) {
          console.warn('FansBRANDS Quick Add: size-chart runtime not found for', root.id);
          return;
        }

        let executableCode = String(sourceScript.textContent || '');

        /*
         * A normál termékoldali snippet a .js-product gyökérből keresi a
         * méretválasztót és a külső triggert. Quick Addban ezt a draweren
         * belül kell keresni, különben a „Tabel de mărimi” gomb nem kap
         * működő click handlert.
         */
        executableCode = executableCode.replace(
          /const\s+productRoot\s*=\s*root\.closest\((['"])\.js-product\1\)\s*\|\|\s*document\s*;/,
          "const productRoot = root.closest('quick-add-drawer') || root.closest('.js-product') || document;"
        );

        const executableScript = document.createElement('script');
        executableScript.setAttribute(
          'data-fb-quick-size-chart-runtime',
          root.id
        );
        executableScript.textContent = executableCode;

        document.body.appendChild(executableScript);
        executableScript.remove();
      });
    }

    /* ==========================================================
       BUTON COȘ – ACEEAȘI STRUCTURĂ CA PE PAGINA PRODUSULUI
       ========================================================== */

    injectCartButtonStyles() {
      if (document.getElementById('fb-quick-add-cart-button-styles')) return;

      const style = document.createElement('style');
      style.id = 'fb-quick-add-cart-button-styles';
      style.textContent = `
        quick-add-drawer button[name="add"] .fb-cro-cart-button__text {
          font-size: calc(1em - 1px) !important;
        }

        quick-add-drawer button[name="add"]::before {
          content: "";
          display: block;
          flex: 0 0 26px;
          width: 26px;
          height: 26px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 26px 26px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 1.9-1.4L20.5 8H7' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='10' cy='19' r='1.5' fill='%23fff'/%3E%3Ccircle cx='17' cy='19' r='1.5' fill='%23fff'/%3E%3C/svg%3E");
          pointer-events: none;
        }

        @media screen and (max-width: 749px) {
          quick-add-drawer button[name="add"] .fb-cro-cart-button__text {
            font-size: clamp(11px, 3.4vw, 14px) !important;
            line-height: 1.15 !important;
            letter-spacing: 0 !important;
            white-space: nowrap !important;
          }

          quick-add-drawer button[name="add"]::before {
            flex-basis: 22px;
            width: 22px;
            height: 22px;
            background-size: 22px 22px;
          }
        }

        quick-add-drawer [data-fb-single-size-option="true"] [data-fb-size-option="true"] {
          display: none !important;
        }

        /* ============================================================
           SELECTOR MĂRIME – IDENTIC CU QUICK ADD-UL MAGHIAR
           ============================================================ */

        quick-add-drawer .fb-quick-cro__options {
          margin-top: 2px;
          margin-bottom: 10px;
        }

        quick-add-drawer .fb-quick-cro__options .label,
        quick-add-drawer .fb-quick-cro__options legend {
          color: #111 !important;
          font-weight: 800 !important;
        }

        quick-add-drawer .fb-quick-cro__options .opt-label {
          min-width: 58px;
          min-height: 42px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          background: #fff;
          color: #111;
          font-weight: 700;
          opacity: 1;
          filter: none;
          cursor: pointer;
        }

        quick-add-drawer .product-options label,
        quick-add-drawer .product-options label[aria-disabled="true"],
        quick-add-drawer .product-options label.is-unavailable,
        quick-add-drawer .product-options label.unavailable,
        quick-add-drawer .product-options label[class*="unavailable"] {
          pointer-events: auto !important;
          cursor: pointer !important;
        }

        /*
         * Stare inițială neutră:
         * chiar dacă tema încearcă să bifeze prima variantă, vizual
         * nu apare nicio mărime selectată până la alegerea clientului.
         */
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-btn:checked + .opt-label,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-btn:disabled + .opt-label,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label.active,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label.selected,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label.is-active,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label.is-selected {
          background: #fff !important;
          background-color: #fff !important;
          background-image: none !important;
          color: #111 !important;
          -webkit-text-fill-color: #111 !important;
          border-color: #d9d9d9 !important;
          opacity: 1 !important;
          filter: none !important;
          box-shadow: none !important;
          outline: none !important;
          transform: none !important;
        }

        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label::before,
        quick-add-drawer .fb-quick-cro.fb-ux-awaiting-size
          [data-fb-size-option="true"] .opt-label::after {
          content: none !important;
          display: none !important;
          opacity: 0 !important;
        }

        /*
         * Mărime indisponibilă:
         * gri + linie diagonală, identic cu versiunea HU.
         */
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          .product-options .opt-label.fb-ux-size-unavailable,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label.fb-ux-size-unavailable,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-btn:disabled + .opt-label,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label.is-unavailable,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label.unavailable,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label[aria-disabled="true"] {
          position: relative;
          overflow: hidden;
          background: #e8e8e8 !important;
          background-color: #e8e8e8 !important;
          border-color: #bdbdbd !important;
          color: #686868 !important;
          -webkit-text-fill-color: #686868 !important;
          opacity: 1 !important;
          filter: none !important;
          cursor: pointer !important;
        }

        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          .product-options .opt-label.fb-ux-size-unavailable::after,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label.fb-ux-size-unavailable::after,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-btn:disabled + .opt-label::after,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label.is-unavailable::after,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label.unavailable::after,
        quick-add-drawer .fb-quick-cro:not(.fb-ux-awaiting-size)
          [data-fb-size-option="true"] .opt-label[aria-disabled="true"]::after {
          content: "";
          position: absolute;
          z-index: 2;
          left: 7%;
          top: 50%;
          width: 86%;
          height: 2px;
          border-radius: 999px;
          background: #3f3f3f;
          pointer-events: none;
          transform: translateY(-50%) rotate(-32deg);
          transform-origin: center;
        }

        /*
         * Mărime selectată:
         * negru + text alb + chenar roșu, identic cu HU.
         */
        quick-add-drawer .fb-quick-cro[data-fb-ux-size-selected="true"]
          [data-fb-size-option="true"] .opt-btn:checked + .opt-label,
        quick-add-drawer .fb-quick-cro[data-fb-ux-size-selected="true"]
          .product-options .opt-btn:checked + .opt-label {
          background: #111111 !important;
          background-color: #111111 !important;
          background-image: none !important;
          box-sizing: border-box;
          border: 3px solid #ff0a18 !important;
          color: #ffffff !important;
          -webkit-text-fill-color: #ffffff !important;
          opacity: 1 !important;
          visibility: visible !important;
          filter: none !important;
          outline: none !important;
          box-shadow:
            0 0 0 1px rgba(237, 16, 26, 0.38),
            inset 0 0 0 1px rgba(0, 0, 0, 0.18) !important;
        }

        quick-add-drawer .fb-quick-cro[data-fb-ux-size-selected="true"]
          [data-fb-size-option="true"] .opt-btn:checked + .opt-label *,
        quick-add-drawer .fb-quick-cro[data-fb-ux-size-selected="true"]
          .product-options .opt-btn:checked + .opt-label *,
        quick-add-drawer .fb-quick-cro[data-fb-ux-size-selected="true"]
          .product-options .opt-btn:checked + .opt-label span,
        quick-add-drawer .fb-quick-cro[data-fb-ux-size-selected="true"]
          .product-options .opt-btn:checked + .opt-label strong {
          color: #ffffff !important;
          -webkit-text-fill-color: #ffffff !important;
          opacity: 1 !important;
          visibility: visible !important;
        }
      `;
      document.head.appendChild(style);
    }

    formatFbMoney(cents, moneyFormat) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function' &&
        moneyFormat
      ) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return (cents / 100).toLocaleString('ro-RO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }) + ' Lei';
    }

    getMoneyFormat() {
      const card = this.getCroPriceCard();
      return (
        (card && card.getAttribute('data-money-format')) ||
        this.getAttribute('data-money-format') ||
        ''
      );
    }

    getCurrentVariantId() {
      let variantInput = null;

      if (this.form) variantInput = this.form.querySelector('[name="id"]');
      if (!variantInput && this.content) variantInput = this.content.querySelector('[name="id"]');

      return variantInput && variantInput.value ? String(variantInput.value) : null;
    }

    getCroPriceCard() {
      return this.content?.querySelector('[data-fb-cro-price-card]') || null;
    }

    getVariantDataset() {
      if (this.fbVariantDataset) return this.fbVariantDataset;
      if (!this.productEl) return null;

      const json = this.productEl.querySelector('variant-picker script[type="application/json"]');
      if (!json) return null;

      try {
        const parsed = JSON.parse(json.textContent || '{}');
        const productData = parsed.product || parsed;
        const variants = Array.isArray(productData.variants) ? productData.variants : [];
        const byId = Object.create(null);

        variants.forEach((variant) => {
          byId[String(variant.id)] = variant;
        });

        this.fbVariantDataset = {
          variants,
          byId,
          options: Array.isArray(productData.options) ? productData.options : []
        };

        return this.fbVariantDataset;
      } catch (error) {
        return null;
      }
    }

    getVariantData(variantId = null) {
      const dataset = this.getVariantDataset();
      if (!dataset || !dataset.variants.length) return null;

      const id = variantId || this.getCurrentVariantId();
      if (id && dataset.byId[String(id)]) return dataset.byId[String(id)];

      return dataset.variants.find((variant) => variant.available) || dataset.variants[0] || null;
    }

    getQuickAddPriceData(variantId = null) {
      const data = this.getVariantData(variantId);
      if (!data) return null;

      const card = this.getCroPriceCard();
      const currentPrice = parseInt(data.price, 10) || 0;
      const comparePrice = parseInt(data.compare_at_price, 10) || 0;
      const originalPrice = comparePrice > currentPrice ? comparePrice : currentPrice;
      const baseSavings = Math.max(0, originalPrice - currentPrice);
      const baseDiscount = originalPrice > 0
        ? Math.round(baseSavings * 100 / originalPrice)
        : 0;

      const mode = card ? (card.getAttribute('data-fb-price-mode') || '') : 'normal';
      const customerVip = Boolean(
        card && card.getAttribute('data-fb-customer-vip') === 'true'
      );
      const vipMultiplier = card
        ? (parseInt(card.getAttribute('data-vip-multiplier'), 10) || 100)
        : 100;
      const vipPrice = Math.round(currentPrice * vipMultiplier / 100);
      const vipSavings = Math.max(0, originalPrice - vipPrice);
      const actualExtraDiscount = 100 - vipMultiplier;
      const communicatedExtra = actualExtraDiscount === 5 || actualExtraDiscount === 6
        ? 5
        : 0;
      const totalDiscountRaw = baseDiscount + communicatedExtra;
      const totalDiscount = totalDiscountRaw > 0
        ? Math.ceil(totalDiscountRaw / 5) * 5
        : 0;

      let buttonPrice = currentPrice;
      let buttonLabel = 'ADAUGĂ ÎN COȘ';
      let buttonMode = mode || 'normal';

      if (mode === 'outlet') {
        buttonLabel = 'ADAUGĂ ÎN COȘ LA PREȚ OUTLET';
        buttonMode = 'outlet';
      } else if (mode === 'vip' && customerVip) {
        buttonPrice = vipPrice;
        buttonLabel = 'ADAUGĂ ÎN COȘ LA PREȚ V.I.P.';
        buttonMode = 'vip';
      } else if (mode === 'vip' && !customerVip && baseDiscount > 0) {
        buttonLabel = 'ADAUGĂ ÎN COȘ LA PREȚ PROMOȚIONAL';
        buttonMode = 'sale';
      } else if (mode === 'sale') {
        buttonLabel = 'ADAUGĂ ÎN COȘ LA PREȚ PROMOȚIONAL';
        buttonMode = 'sale';
      } else {
        buttonMode = 'normal';
      }

      return {
        data,
        currentPrice,
        comparePrice,
        originalPrice,
        baseSavings,
        baseDiscount,
        vipMultiplier,
        vipPrice,
        vipSavings,
        totalDiscount,
        totalDiscountRaw,
        communicatedExtra,
        actualExtraDiscount,
        mode,
        customerVip,
        buttonPrice,
        buttonLabel,
        buttonMode,
        moneyFormat: this.getMoneyFormat()
      };
    }

    updateQuickAddPrice(variantId = null) {
      const priceData = this.getQuickAddPriceData(variantId);
      if (!priceData) return;

      const priceBlock = this.content?.querySelector('.quick-add-mobile-price');
      if (!priceBlock) return;

      const originalEl = priceBlock.querySelector('[data-fb-original-price]');
      const saleEl = priceBlock.querySelector('[data-fb-sale-price]');
      const vipEl = priceBlock.querySelector('[data-fb-vip-price]');
      const baseBadge = priceBlock.querySelector('[data-fb-base-discount]');
      const vipExtraBadge = priceBlock.querySelector('[data-fb-vip-extra]');
      const vipSavingEl = priceBlock.querySelector('[data-fb-vip-saving]');
      const vipJoinPriceEl = priceBlock.querySelector('[data-fb-vip-join-price]');
      const totalDiscountEl = priceBlock.querySelector('[data-fb-total-discount]');
      const baseSavingEl = priceBlock.querySelector('[data-fb-base-saving]');

      const originalCell = originalEl?.closest('.fb-cro-price-cell') || null;
      const saleCell = saleEl?.closest('.fb-cro-price-cell') || null;
      const vipCell = vipEl?.closest('.fb-cro-price-cell') || null;
      const vipCustomerActive = priceData.mode === 'vip' && priceData.customerVip;
      const vipSaleShouldStrike = vipCustomerActive && priceData.baseDiscount > 0;

      if (originalCell) originalCell.classList.add('fb-cro-price-cell--inactive');

      if (saleCell) {
        saleCell.classList.remove('fb-cro-price-cell--active');
        saleCell.classList.toggle('fb-cro-price-cell--inactive', vipCustomerActive);
        saleCell.classList.toggle('fb-vip-sale-price-row', vipSaleShouldStrike);
      }

      if (vipCell) vipCell.classList.add('fb-cro-price-cell--active');

      if (originalEl) {
        originalEl.textContent = this.formatFbMoney(priceData.originalPrice, priceData.moneyFormat);
      }

      if (saleEl) {
        saleEl.textContent = this.formatFbMoney(priceData.currentPrice, priceData.moneyFormat);
      }

      if (vipEl) {
        vipEl.textContent = this.formatFbMoney(priceData.vipPrice, priceData.moneyFormat);
      }

      if (baseBadge) {
        baseBadge.textContent = '-' + priceData.baseDiscount + '%';
        baseBadge.hidden = priceData.baseDiscount <= 0;
      }

      if (vipExtraBadge && priceData.mode === 'vip') {
        vipExtraBadge.textContent = 'încă -' + priceData.communicatedExtra + '%';
      }

      if (vipSavingEl) {
        vipSavingEl.textContent = this.formatFbMoney(priceData.vipSavings, priceData.moneyFormat);
      }

      if (vipJoinPriceEl) {
        vipJoinPriceEl.textContent = this.formatFbMoney(priceData.vipPrice, priceData.moneyFormat);
      }

      if (totalDiscountEl) totalDiscountEl.textContent = priceData.totalDiscount + '%';

      if (baseSavingEl) {
        baseSavingEl.textContent = this.formatFbMoney(priceData.baseSavings, priceData.moneyFormat);
      }

      this.syncAccordionData();
      this.renderQuickAddCartButton(variantId);
    }

    renderQuickAddCartButton(variantId = null) {
      if (!this.form) return;

      const addButton = this.form.querySelector('button[name="add"]');
      if (!addButton) return;

      const priceData = this.getQuickAddPriceData(variantId);
      if (!priceData) return;

      const formattedPrice = this.formatFbMoney(
        priceData.buttonPrice,
        priceData.moneyFormat
      );
      const expectedText = priceData.buttonLabel + ' – ' + formattedPrice;

      addButton.setAttribute('data-fb-current-button-price', priceData.buttonPrice);
      addButton.setAttribute('data-fb-current-button-mode', priceData.buttonMode);
      addButton.setAttribute('data-fb-button-text', expectedText);
      addButton.setAttribute('data-add-to-cart-text', expectedText);

      let textNode = addButton.querySelector('.fb-cro-cart-button__text');

      addButton.querySelectorAll('.fb-cro-cart-button__icon').forEach((icon) => icon.remove());

      if (!textNode) {
        addButton.textContent = '';
        textNode = document.createElement('span');
        textNode.className = 'fb-cro-cart-button__text';
        addButton.appendChild(textNode);
      }

      if (textNode.textContent.trim() !== expectedText) {
        textNode.textContent = expectedText;
      }

      this.syncQuickAddButtonForSizeState();
    }

    scheduleQuickAddCroUpdate(variantId = null) {
      [0, 60, 160, 320].forEach((delay) => {
        window.setTimeout(() => {
          this.updateQuickAddPrice(variantId);
          this.syncUnavailableSizes();
          this.syncQuickAddButtonForSizeState();
        }, delay);
      });
    }

    bindCartButtonObserver() {
      if (!this.form || !window.MutationObserver) return;
      const addButton = this.form.querySelector('button[name="add"]');
      if (!addButton) return;

      if (this.fbCartButtonObserver) this.fbCartButtonObserver.disconnect();

      let scheduled = false;
      this.fbCartButtonObserver = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;

        window.requestAnimationFrame(() => {
          scheduled = false;
          this.syncQuickAddButtonForSizeState();
          this.renderQuickAddCartButton();
        });
      });

      this.fbCartButtonObserver.observe(addButton, {
        attributes: true,
        attributeFilter: ['disabled', 'data-add-to-cart-text'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    /* ==========================================================
       SELECTARE MĂRIME – ACELEAȘI STĂRI CA PE PAGINA PRODUSULUI
       ========================================================== */

    normalizeFb(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9]/g, '');
    }

    fbKnownSizeValues() {
      return new Set([
        'xxs', 'xs', 's', 'm', 'l', 'xl',
        '2xl', 'xxl', '3xl', 'xxxl', '4xl', 'xxxxl',
        '5xl', 'xxxxxl', '6xl',
        'sm', 's-m', 'ml', 'm-l', 'lxl', 'l-xl',
        'onesize', 'one-size', 'os',
        'osfa', 'osfb', 'osft', 'osfc', 'osfy', 'osfw', 'osfm', 'osfl',
        'youth',
        'uni', 'universal', 'universala', 'unisex'
      ].map((value) => this.normalizeFb(value)));
    }

    isLikelySizeValue(value) {
      const normalized = this.normalizeFb(value);
      if (!normalized) return false;

      if (this.fbKnownSizeValues().has(normalized)) return true;

      // Pantofi / copii: 28, 39, 40, 116, 128 etc.
      if (/^\d{2,3}$/.test(normalized)) {
        const number = parseInt(normalized, 10);
        return Number.isFinite(number) && number >= 20 && number <= 200;
      }

      // Mărimi de pantofi de tip 39 1/3, 42 2/3 etc.
      if (/^\d{2,3}(13|23)$/.test(normalized)) return true;

      return false;
    }

    groupLooksLikeSize(group) {
      if (!group) return false;
      if (group.matches?.('[data-fb-size-option="true"]')) return true;

      const controls = Array.from(
        group.querySelectorAll('input[type="radio"], select')
      );

      const values = [];

      controls.forEach((control) => {
        if (control.matches('select')) {
          Array.from(control.options || []).forEach((option) => {
            const value = option.value || option.textContent;
            if (String(value || '').trim()) values.push(value);
          });
        } else if (String(control.value || '').trim()) {
          values.push(control.value);
        }
      });

      if (!values.length) return false;

      return values.every((value) => this.isLikelySizeValue(value));
    }

    foldFbText(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    looksLikeSizeName(value) {
      const text = ' ' + this.foldFbText(value) + ' ';
      return (
        text.includes(' size ') ||
        text.includes(' meret ') ||
        text.includes(' cipomeret ') ||
        text.includes(' labbeli meret ') ||
        text.includes(' fejmeret ') ||
        text.includes(' shoe size ') ||
        text.includes(' hat size ') ||
        text.includes(' marime ') ||
        text.includes(' marimea ') ||
        text.includes(' marime pantofi ') ||
        text.includes(' marime sapca ')
      );
    }

    controlIsSize(control) {
      if (!control) return false;
      if (control.closest('[data-fb-size-option="true"]')) return true;

      const context = [
        control.name,
        control.id,
        control.getAttribute('aria-label'),
        control.getAttribute('data-option-name'),
        control.getAttribute('data-name'),
        control.getAttribute('data-option')
      ];

      const group = control.closest(
        'fieldset, .option-selector, [data-option-name], [data-selector-type]'
      );

      if (group) {
        context.push(
          group.getAttribute('aria-label'),
          group.getAttribute('data-option-name'),
          group.getAttribute('data-name'),
          group.getAttribute('data-option')
        );

        const heading = group.querySelector(
          'legend, .label, .option-selector__label, [data-option-label]'
        );
        if (heading) context.push(heading.textContent);
      }

      return (
        this.looksLikeSizeName(context.join(' ')) ||
        this.groupLooksLikeSize(group) ||
        this.isLikelySizeValue(control.value)
      );
    }

    markSizeOptionGroups() {
      if (!this.content) return;

      const groups = Array.from(this.content.querySelectorAll(
        '.product-options fieldset, .product-options .option-selector, .product-options [data-option-name], .product-options [data-selector-type]'
      ));

      groups.forEach((group) => {
        const controls = Array.from(
          group.querySelectorAll('input[type="radio"], select')
        );

        if (!controls.length) return;

        const isSize = controls.some((control) => this.controlIsSize(control));
        if (!isSize) return;

        group.setAttribute('data-fb-size-option', 'true');

        const heading = group.querySelector(
          'legend, .label, .option-selector__label, [data-option-label]'
        );

        if (heading) {
          const colorValue = heading.querySelector('.option-selector__label-value');
          if (colorValue) colorValue.textContent = '';

          // A magyar "Méretek:" román megfelelője.
          const textNodes = Array.from(heading.childNodes)
            .filter((node) => node.nodeType === Node.TEXT_NODE);

          if (textNodes.length) {
            textNodes[0].nodeValue = 'Mărimi:';
          } else {
            heading.insertAdjacentText('afterbegin', 'Mărimi:');
          }
        }

        const sizeChartLink = group.querySelector(
          '[data-fbsc-open], modal-opener[data-modal="size-chart"] button, a[href*="size"], .size-chart-link'
        );

        if (sizeChartLink) {
          sizeChartLink.textContent = 'Tabel de mărimi';
          sizeChartLink.setAttribute('title', 'Tabel de mărimi și ghid de măsurare');
        }
      });
    }

    getSizeRadios() {
      if (!this.content) return [];
      return Array.from(this.content.querySelectorAll('.product-options input[type="radio"]'))
        .filter((input) => this.controlIsSize(input));
    }

    getSizeSelects() {
      if (!this.content) return [];

      return Array.from(this.content.querySelectorAll('.product-options select'))
        .filter((select) => {
          const group = select.closest(
            '[data-fb-size-option="true"], fieldset, .option-selector, [data-option-name], [data-selector-type]'
          );

          return (
            this.controlIsSize(select) ||
            this.groupLooksLikeSize(group)
          );
        });
    }

    hasSingleSizeOption() {
      // 1) Ha a román main-product már kiadja a flaget, ezt használjuk.
      if (
        this.productEl?.querySelector(
          '.product-info[data-fb-single-size-option="true"]'
        )
      ) {
        return true;
      }

      // 2) Önálló Quick Add fallback:
      // megkeressük a Size / Méret / Mărime opciót a termék JSON-ban.
      // Ha pontosan 1 különböző értéke van, nincs valódi választás.
      const dataset = this.getVariantDataset();
      if (dataset && Array.isArray(dataset.variants) && dataset.variants.length) {
        const optionNames = Array.isArray(dataset.options) ? dataset.options : [];

        for (let index = 0; index < optionNames.length; index += 1) {
          const rawName = typeof optionNames[index] === 'string'
            ? optionNames[index]
            : (optionNames[index]?.name || '');

          const values = new Set();
          const rawValues = [];

          dataset.variants.forEach((variant) => {
            const options = Array.isArray(variant.options)
              ? variant.options
              : [variant.option1, variant.option2, variant.option3];

            const rawValue = options[index];
            const normalized = this.normalizeFb(rawValue);
            if (normalized) {
              values.add(normalized);
              rawValues.push(rawValue);
            }
          });

          const optionLooksLikeSize =
            this.looksLikeSizeName(rawName) ||
            (
              rawValues.length > 0 &&
              rawValues.every((value) => this.isLikelySizeValue(value))
            );

          if (!optionLooksLikeSize) continue;
          if (values.size === 1) return true;
        }
      }

      // 3) DOM fallback.
      const values = new Set();

      this.getSizeRadios().forEach((control) => {
        const normalized = this.normalizeFb(control.value);
        if (normalized) values.add(normalized);
      });

      this.getSizeSelects().forEach((select) => {
        Array.from(select.options || []).forEach((option) => {
          const normalized = this.normalizeFb(option.value || option.textContent);
          if (normalized) values.add(normalized);
        });
      });

      return values.size === 1;
    }

    hideSingleSizeOption() {
      if (!this.hasSingleSizeOption() || !this.content) return false;

      const root = this.content.querySelector('[data-fb-quick-root]');
      if (root) {
        root.setAttribute('data-fb-single-size-option', 'true');
        root.setAttribute('data-fb-ux-size-selected', 'true');
        root.classList.remove('fb-ux-awaiting-size');
      }

      const controls = [
        ...this.getSizeRadios(),
        ...this.getSizeSelects()
      ];

      controls.forEach((control) => {
        const group = control.closest(
          '[data-fb-size-option="true"], fieldset, .option-selector, [data-option-name], [data-selector-type]'
        );

        if (group) {
          group.hidden = true;
          group.style.setProperty('display', 'none', 'important');
        }
      });

      const error = this.content.querySelector('[data-fb-quick-size-error]');
      if (error) error.hidden = true;

      this.fbSizeSelected = true;
      return true;
    }

    hasSizeSelector() {
      if (this.hasSingleSizeOption()) return false;
      return this.getSizeRadios().length > 0 || this.getSizeSelects().length > 0;
    }

    sizeChosen() {
      return !this.hasSizeSelector() || this.fbSizeSelected;
    }

    optionIndexForControl(control) {
      const dataset = this.getVariantDataset();
      const optionNames = dataset?.options || [];
      const nameMatch = String(control?.name || '').match(/options\[([^\]]+)\]/i);

      if (nameMatch && optionNames.length) {
        const sought = this.normalizeFb(nameMatch[1]);
        const index = optionNames.findIndex((name) => this.normalizeFb(name) === sought);
        if (index >= 0) return index;
      }

      const explicit = control?.closest('[data-option-index]')?.getAttribute('data-option-index');
      if (explicit !== null && explicit !== undefined && explicit !== '') {
        const parsed = parseInt(explicit, 10);
        if (Number.isFinite(parsed)) return parsed > 0 ? parsed - 1 : parsed;
      }

      const groups = Array.from(this.content.querySelectorAll(
        '.product-options fieldset, .product-options .option-selector'
      ));
      const group = control?.closest('fieldset, .option-selector');
      const groupIndex = groups.indexOf(group);
      return groupIndex >= 0 ? groupIndex : 0;
    }

    sizeIsAvailable(control, value) {
      const dataset = this.getVariantDataset();
      if (!dataset || !dataset.variants.length) return !control.disabled;

      const optionIndex = this.optionIndexForControl(control);
      const normalizedValue = this.normalizeFb(value);

      return dataset.variants.some((variant) => {
        const options = variant.options || [variant.option1, variant.option2, variant.option3];
        return Boolean(variant.available) &&
          this.normalizeFb(options[optionIndex]) === normalizedValue;
      });
    }

    getLabelForControl(control) {
      if (!control) return null;

      if (control.id) {
        const escaped = window.CSS && CSS.escape ? CSS.escape(control.id) : control.id;
        const label = this.content.querySelector(`label[for="${escaped}"]`);
        if (label) return label;
      }

      if (control.nextElementSibling?.matches('label')) return control.nextElementSibling;
      return control.closest('label');
    }

    syncUnavailableSizes() {
      this.getSizeRadios().forEach((control) => {
        const label = this.getLabelForControl(control);
        if (!label) return;

        const unavailable = !this.sizeIsAvailable(control, control.value);
        label.classList.toggle('fb-ux-size-unavailable', unavailable);
      });
    }

    resetUnselectedSizeControls() {
      if (!this.content || this.fbSizeSelected) return;

      this.markSizeOptionGroups();

      this.getSizeRadios().forEach((control) => {
        control.checked = false;
        control.defaultChecked = false;
        control.removeAttribute('checked');

        const label = this.getLabelForControl(control);
        if (label) {
          label.classList.remove(
            'active',
            'selected',
            'is-active',
            'is-selected'
          );
          label.setAttribute('aria-checked', 'false');
        }
      });

      this.getSizeSelects().forEach((select) => {
        select.selectedIndex = -1;
      });
    }

    scheduleInitialSizeNeutralState() {
      if (!this.content || this.fbSizeSelected) return;

      const run = () => {
        if (this.fbSizeSelected) return;
        this.resetUnselectedSizeControls();

        const root = this.content?.querySelector('[data-fb-quick-root]');
        if (root && this.hasSizeSelector()) {
          root.setAttribute('data-fb-ux-size-selected', 'false');
          root.classList.add('fb-ux-awaiting-size');
        }
      };

      run();
      window.requestAnimationFrame(run);
      [100, 300, 700].forEach((delay) => {
        window.setTimeout(run, delay);
      });
    }

    prepareEmptySizeState() {
      const root = this.content?.querySelector('[data-fb-quick-root]');
      if (!root) return;

      this.markSizeOptionGroups();
      this.hideSingleSizeOption();

      const hasSize = this.hasSizeSelector();

      if (hasSize && !this.fbSizeSelected) {
        this.resetUnselectedSizeControls();
        this.scheduleInitialSizeNeutralState();
      }

      root.setAttribute('data-fb-ux-size-selected', hasSize && this.fbSizeSelected ? 'true' : 'false');
      root.classList.toggle('fb-ux-awaiting-size', hasSize && !this.fbSizeSelected);

      this.syncUnavailableSizes();
      this.syncQuickAddButtonForSizeState();
      this.syncInventoryVisibility();
    }

    confirmSizeSelection() {
      this.fbSizeSelected = true;
      const root = this.content?.querySelector('[data-fb-quick-root]');
      if (root) {
        root.setAttribute('data-fb-ux-size-selected', 'true');
        root.classList.remove('fb-ux-awaiting-size');
      }

      const error = this.content?.querySelector('[data-fb-quick-size-error]');
      if (error) error.hidden = true;

      this.syncInventoryVisibility();
      this.scheduleQuickAddInventoryDeliveryUpdate();
    }

    showSizeError() {
      const options = this.content?.querySelector('.product-options');
      if (!options) return;

      let error = options.querySelector('[data-fb-quick-size-error]');
      if (!error) {
        error = document.createElement('div');
        error.className = 'fb-ux-size-error';
        error.setAttribute('data-fb-quick-size-error', '');
        error.setAttribute('role', 'alert');
        error.textContent = 'Te rugăm să alegi mărimea';
        options.appendChild(error);
      }

      error.hidden = false;
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    syncQuickAddButtonForSizeState() {
      if (!this.form) return;
      const button = this.form.querySelector('button[name="add"]');
      if (!button) return;

      const awaitingSize = this.hasSizeSelector() && !this.fbSizeSelected;
      const productAvailable = button.getAttribute('data-fb-product-available') !== 'false';

      if (awaitingSize && productAvailable) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      }

      const expectedText = button.getAttribute('data-fb-button-text') || '';
      if (expectedText) {
        let textNode = button.querySelector('.fb-cro-cart-button__text');
        if (!textNode) {
          button.textContent = '';
          textNode = document.createElement('span');
          textNode.className = 'fb-cro-cart-button__text';
          button.appendChild(textNode);
        }
        if (textNode.textContent.trim() !== expectedText.trim()) {
          textNode.textContent = expectedText.trim();
        }
      }
    }

    sizeControlFromClick(target) {
      if (!target?.closest) return null;
      const direct = target.closest('input[type="radio"]');
      if (direct) return direct;

      const label = target.closest('label');
      if (!label) return null;

      if (label.htmlFor) {
        const linked = this.content.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(label.htmlFor) : label.htmlFor));
        if (linked) return linked;
      }

      return label.querySelector('input[type="radio"]');
    }

    handleDrawerClick(event) {
      const sizeControl = this.sizeControlFromClick(event.target);

      if (sizeControl && this.controlIsSize(sizeControl)) {
        if (!this.sizeIsAvailable(sizeControl, sizeControl.value)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (event.isTrusted) {
          this.confirmSizeSelection();
        }
      }

      const addButton = event.target.closest('button[name="add"]');
      if (addButton && this.contains(addButton) && !this.sizeChosen()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showSizeError();
      }
    }

    handleSizeChartSelect(event) {
      if (event.detail?.source !== 'fb-size-chart') return;
      if (!event.target?.closest?.('.product-options')) return;

      this.fbSizeChartSelectionPending = true;

      window.setTimeout(() => {
        this.fbSizeChartSelectionPending = false;
      }, 700);
    }

    handleDrawerChange(event) {
      if (!event.target.closest?.('.product-options')) return;

      if (
        (event.isTrusted || this.fbSizeChartSelectionPending) &&
        event.target.matches('input[type="radio"], select') &&
        this.controlIsSize(event.target)
      ) {
        this.fbSizeChartSelectionPending = false;
        this.confirmSizeSelection();
      }

      this.scheduleQuickAddCroUpdate();
    }

    handleDrawerSubmit(event) {
      if (!this.form || !this.form.contains(event.target)) return;
      if (this.sizeChosen()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.showSizeError();
    }

    /* ==========================================================
       STOC + LIVRARE ESTIMATĂ
       ========================================================== */

    syncInventoryVisibility() {
      const target = this.content?.querySelector('[data-fb-quick-add-inventory-delivery]');
      if (!target) return;
      target.hidden = this.hasSizeSelector() && !this.fbSizeSelected;
    }

    scheduleQuickAddInventoryDeliveryUpdate(variantId = null) {
      [30, 120, 300].forEach((delay) => {
        window.setTimeout(() => {
          this.updateQuickAddInventoryAndDelivery(
            variantId || this.getCurrentVariantId()
          );
        }, delay);
      });
    }

    extractInventoryQuantity(text) {
      if (!text) return null;

      const normalized = String(text)
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      const patterns = [
        /(^|\s)(\d{1,5})(?=\s*(?:buc\.?\s*)?(?:în|in)\s+stoc\b)/i,
        /(^|\s)(\d{1,5})(?=\s*buc\.?\b)/i,
        /(?:doar|numai|au mai rămas|au mai ramas)\s*(\d{1,5})\b/i,
        /(^|\s)(\d{1,5})(?=\s*(?:db\s*)?raktáron\b)/i
      ];

      for (const pattern of patterns) {
        const match = normalized.match(pattern);
        if (!match) continue;

        const raw = typeof match[2] !== 'undefined' ? match[2] : match[1];
        const quantity = parseInt(raw, 10);

        if (Number.isFinite(quantity)) return quantity;
      }

      return null;
    }

    async updateQuickAddInventoryAndDelivery(variantId = null) {
      const target = this.content?.querySelector('[data-fb-quick-add-inventory-delivery]');
      if (!target || !this.productUrl) return;

      this.syncInventoryVisibility();
      if (target.hidden) return;

      const requestId = ++this.fbInventoryRequestId;
      const resolvedVariantId = variantId ? String(variantId) : this.getCurrentVariantId();
      let sourceProduct = this.productEl;

      if (resolvedVariantId) {
        try {
          const variantUrl = new URL(this.productUrl, window.location.origin);
          variantUrl.searchParams.set('variant', resolvedVariantId);

          const response = await fetch(variantUrl.toString(), {
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (response.ok) {
            const template = document.createElement('template');
            template.innerHTML = await response.text();
            const fetchedProduct = template.content.querySelector('.cc-main-product .js-product');
            if (fetchedProduct) sourceProduct = fetchedProduct;
          }
        } catch (error) {
          sourceProduct = this.productEl;
        }
      }

      if (requestId !== this.fbInventoryRequestId) return;

      let inventoryLevel = '';
      let inventoryText = '';
      let inventoryQuantity = null;
      let addAvailable = true;

      if (sourceProduct) {
        const inventoryStatus = sourceProduct.querySelector('[data-inventory-level]');
        if (inventoryStatus) {
          inventoryLevel = inventoryStatus.getAttribute('data-inventory-level') || '';
          inventoryText = inventoryStatus.textContent ? inventoryStatus.textContent.trim() : '';
          inventoryQuantity = this.extractInventoryQuantity(inventoryText);
        }

        const sourceAddButton = sourceProduct.querySelector(
          '.js-product-form-main button[name="add"], product-form button[name="add"]'
        );
        if (sourceAddButton) addAvailable = !sourceAddButton.disabled;
      }

      const normalizedInventoryLevel = String(inventoryLevel || '').trim().toLowerCase();
      const isBackordered = ['backordered', 'backorder'].includes(normalizedInventoryLevel);
      const isOut = ['out_of_stock', 'no_stock', 'sold_out', 'unavailable'].includes(normalizedInventoryLevel) ||
        (addAvailable === false && !isBackordered);

      let statusClass = '';
      let statusText = 'În stoc';
      let barHtml = '';
      let showDelivery = true;

      if (isBackordered) {
        statusClass = ' fb-quick-add-stock-status--backorder';
        statusText = 'Disponibil la comandă';
        showDelivery = false;
      } else if (isOut) {
        statusClass = ' fb-quick-add-stock-status--out';
        statusText = 'Stoc epuizat';
        showDelivery = false;
      } else if (
        inventoryQuantity !== null &&
        inventoryQuantity > 0 &&
        inventoryQuantity < 10
      ) {
        statusText = `${inventoryQuantity} buc. în stoc`;
        const lowWidth = Math.max(10, Math.min(90, inventoryQuantity * 10));
        barHtml = `
          <div class="fb-quick-add-stock-bar" aria-hidden="true">
            <span class="fb-quick-add-stock-bar__fill fb-quick-add-stock-bar__fill--low" style="width:${lowWidth}%;"></span>
          </div>
        `;
      } else {
        barHtml = `
          <div class="fb-quick-add-stock-bar" aria-hidden="true">
            <span class="fb-quick-add-stock-bar__fill fb-quick-add-stock-bar__fill--normal" style="width:100%;"></span>
          </div>
        `;
      }

      target.innerHTML = `
        <div class="fb-quick-add-stock-status${statusClass}">
          <span class="fb-quick-add-stock-dot" aria-hidden="true"></span>
          <span>${statusText}</span>
        </div>
        ${barHtml}
        ${showDelivery
          ? `<div class="fb-quick-add-delivery">Livrare estimată: <span class="fb-quick-add-delivery__date">${this.getFbDeliveryDateRange()}</span></div>`
          : ''}
      `;
    }

    fbDeliveryDateKey(date) {
      return [
        date.getUTCFullYear(),
        String(date.getUTCMonth() + 1).padStart(2, '0'),
        String(date.getUTCDate()).padStart(2, '0')
      ].join('-');
    }

    fbDeliveryAddCalendarDays(date, days) {
      const result = new Date(date.getTime());
      result.setUTCDate(result.getUTCDate() + days);
      return result;
    }

    fbDeliveryEasterSunday(year) {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(Date.UTC(year, month - 1, day));
    }

    fbDeliveryOrthodoxEasterSunday(year) {
      const a = year % 4;
      const b = year % 7;
      const c = year % 19;
      const d = (19 * c + 15) % 30;
      const e = (2 * a + 4 * b - d + 34) % 7;
      const month = Math.floor((d + e + 114) / 31);
      const day = ((d + e + 114) % 31) + 1;

      // Conversie din calendarul iulian în cel gregorian (valabilă 1900–2099).
      return new Date(Date.UTC(year, month - 1, day + 13));
    }

    fbDeliveryIsRomanianHoliday(date) {
      const year = date.getUTCFullYear();
      const month = date.getUTCMonth() + 1;
      const day = date.getUTCDate();

      const fixedHolidays = {
        '1-1': true,
        '1-2': true,
        '1-6': true,
        '1-7': true,
        '1-24': true,
        '5-1': true,
        '6-1': true,
        '8-15': true,
        '11-30': true,
        '12-1': true,
        '12-25': true,
        '12-26': true
      };

      if (fixedHolidays[`${month}-${day}`]) return true;

      const easterSunday = this.fbDeliveryOrthodoxEasterSunday(year);
      const goodFriday = this.fbDeliveryAddCalendarDays(easterSunday, -2);
      const easterMonday = this.fbDeliveryAddCalendarDays(easterSunday, 1);
      const pentecostMonday = this.fbDeliveryAddCalendarDays(easterSunday, 50);
      const key = this.fbDeliveryDateKey(date);

      return (
        key === this.fbDeliveryDateKey(goodFriday) ||
        key === this.fbDeliveryDateKey(easterMonday) ||
        key === this.fbDeliveryDateKey(pentecostMonday)
      );
    }

    fbDeliveryIsPackingBusinessDay(date) {
      const weekday = date.getUTCDay();
      if (weekday === 0 || weekday === 6) return false;
      return !this.fbDeliveryIsRomanianHoliday(date);
    }

    fbDeliveryGetBucharestToday() {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Bucharest',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());

      const values = {};
      parts.forEach((part) => {
        if (part.type !== 'literal') values[part.type] = part.value;
      });

      return new Date(Date.UTC(
        parseInt(values.year, 10),
        parseInt(values.month, 10) - 1,
        parseInt(values.day, 10)
      ));
    }

    fbDeliveryAddPackingBusinessDays(startDate, numberOfDays) {
      const date = new Date(startDate.getTime());
      let completed = 0;

      while (completed < numberOfDays) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (this.fbDeliveryIsPackingBusinessDay(date)) completed += 1;
      }

      return date;
    }

    fbDeliveryMonthName(monthIndex) {
      return [
        'ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie',
        'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie'
      ][monthIndex];
    }

    fbDeliveryFormatRomanianDateRange(firstDate, secondDate) {
      const firstYear = firstDate.getUTCFullYear();
      const secondYear = secondDate.getUTCFullYear();
      const firstMonth = firstDate.getUTCMonth();
      const secondMonth = secondDate.getUTCMonth();
      const firstDay = firstDate.getUTCDate();
      const secondDay = secondDate.getUTCDate();

      if (firstYear === secondYear && firstMonth === secondMonth) {
        return `${firstDay}–${secondDay} ${this.fbDeliveryMonthName(firstMonth)}`;
      }

      if (firstYear === secondYear) {
        return `${firstDay} ${this.fbDeliveryMonthName(firstMonth)} – ${secondDay} ${this.fbDeliveryMonthName(secondMonth)}`;
      }

      return `${firstDay} ${this.fbDeliveryMonthName(firstMonth)} ${firstYear} – ${secondDay} ${this.fbDeliveryMonthName(secondMonth)} ${secondYear}`;
    }

    getFbDeliveryDateRange() {
      const today = this.fbDeliveryGetBucharestToday();
      const firstExpectedDate = this.fbDeliveryAddPackingBusinessDays(today, 2);
      const secondExpectedDate = this.fbDeliveryAddPackingBusinessDays(today, 4);

      return this.fbDeliveryFormatRomanianDateRange(
        firstExpectedDate,
        secondExpectedDate
      );
    }

    /* ==========================================================
       ACCORDION PAGINĂ PRODUS – V.I.P. / LIVRARE / RETUR 180 ZILE
       ========================================================== */

    accordionIcon(type) {
      const icons = {
        vip: '<svg viewBox="0 0 48 48" fill="none"><path d="M7 36h34M10 31 7 14l11 9 6-15 6 15 11-9-3 17H10Z" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round"/><circle cx="7" cy="12" r="3" fill="currentColor"/><circle cx="24" cy="6" r="3" fill="currentColor"/><circle cx="41" cy="12" r="3" fill="currentColor"/></svg>',
        truck: '<svg viewBox="0 0 48 48" fill="none"><path d="M5 11h24v23H5V11Zm24 9h8l6 7v7H29V20Z" stroke="currentColor" stroke-width="3"/><circle cx="14" cy="36" r="4" stroke="currentColor" stroke-width="3"/><circle cx="36" cy="36" r="4" stroke="currentColor" stroke-width="3"/></svg>',
        return: '<svg viewBox="0 0 48 48" fill="none"><path d="M15 13H7v-8M8 12c4-5 9-8 16-8 11 0 20 9 20 20s-9 20-20 20c-8 0-15-5-18-12" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      };
      return icons[type] || icons.truck;
    }

    makeAccordion({ key, className = '', title, icon, html }) {
      const details = document.createElement('details');
      details.className = 'fb-ux-accordion' + (className ? ' ' + className : '');
      details.setAttribute('data-fb-quick-accordion', '');
      details.setAttribute('data-fb-quick-accordion-key', key);

      details.innerHTML = `
        <summary class="fb-ux-accordion__summary">
          <span class="fb-ux-accordion__icon" aria-hidden="true">${this.accordionIcon(icon)}</span>
          <span class="fb-ux-accordion__copy"><strong>${title}</strong></span>
          <span class="fb-ux-accordion__chevron" aria-hidden="true"></span>
        </summary>
        <div class="fb-ux-accordion__content">${html}</div>
      `;

      return details;
    }

    buildVipContent() {
      const source = this.content?.querySelector(
        '.quick-add-mobile-price .fb-cro-vip-active, .quick-add-mobile-price .fb-cro-vip-join'
      );
      const isActive = Boolean(source?.classList.contains('fb-cro-vip-active'));
      const priceSource = this.content?.querySelector(
        '[data-fb-vip-join-price], [data-fb-vip-price]'
      );
      const vipPrice = priceSource ? priceSource.textContent.replace(/\s+/g, ' ').trim() : '';
      const loginLink = source?.querySelector('.fb-cro-vip-join__login a')?.getAttribute('href') || '/account/login';

      return `
        <div class="fb-pa-body">
          <div class="fb-pa-title">
            ${isActive
              ? 'Calitatea ta de membru V.I.P. este <span class="fb-pa-red">activă</span>'
              : (vipPrice
                ? `Cumpără acum la prețul V.I.P. de <span class="fb-pa-red" data-fb-quick-vip-price>${vipPrice}</span>!`
                : 'Înscrie-te în <span class="fb-pa-red">Clubul V.I.P.</span>')}
          </div>
          <p class="fb-pa-subtitle">
            ${isActive
              ? 'Reducerea V.I.P. se aplică automat.'
              : 'Membru gratuit pe viață. Nu este abonament.'}
          </p>
          <div class="fb-pa-check-list">
            <div class="fb-pa-check-row"><span class="fb-pa-check" aria-hidden="true">✓</span><span>Reducere V.I.P. suplimentară</span></div>
            <div class="fb-pa-check-row"><span class="fb-pa-check" aria-hidden="true">✓</span><span>Preț V.I.P. automat după autentificare</span></div>
            <div class="fb-pa-check-row"><span class="fb-pa-check" aria-hidden="true">✓</span><span>Oferte exclusive și noutăți</span></div>
          </div>
          ${!isActive
            ? '<button type="button" class="fb-pa-cta" data-fb-vip-popup-open>MĂ ÎNSCRIU GRATUIT</button>' +
              `<div class="fb-pa-login">Ești deja membru? <a href="${loginLink}">AUTENTIFICARE</a></div>`
            : ''}
        </div>
      `;
    }

    buildFreeShippingContent() {
      return `
        <div class="fb-pa-body fb-pa-free-shipping">
          <div class="fb-pa-free-card fb-pa-free-card--new">
            <div class="fb-pa-free-card__icon" aria-hidden="true">
              <svg viewBox="0 0 64 52" fill="none"><path d="M7 17 42 4l15 10-4 31-36 4L4 37 7 17Z" fill="currentColor"/><circle cx="46" cy="14" r="3.5" fill="#fff"/><text x="30" y="34" fill="#fff" font-size="17" font-weight="900" text-anchor="middle" transform="rotate(-13 30 34)">NEW</text></svg>
            </div>
            <div class="fb-pa-free-card__copy">
              <strong>PRODUSE NOI 2026</strong>
              <span>Livrare gratuită la cumpărături de peste 300 Lei.</span>
            </div>
          </div>
          <div class="fb-pa-free-card fb-pa-free-card--other">
            <div class="fb-pa-free-card__icon" aria-hidden="true">
              <svg viewBox="0 0 64 52" fill="none"><path d="M5 10h34v28H5V10Zm34 12h10l10 10v6H39V22Z" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/><circle cx="17" cy="41" r="7" stroke="currentColor" stroke-width="4"/><circle cx="49" cy="41" r="7" stroke="currentColor" stroke-width="4"/></svg>
            </div>
            <div class="fb-pa-free-card__copy">
              <strong>TOATE CELELALTE PRODUSE</strong>
              <span>Livrare gratuită la comenzi de peste 700 Lei.</span>
            </div>
          </div>
          <div class="fb-pa-free-note">
            <svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2.5"/><path d="M16 14v9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/><circle cx="16" cy="9.5" r="1.7" fill="currentColor"/></svg>
            <em>Aplicăm întotdeauna condiția mai avantajoasă pentru tine.</em>
          </div>
        </div>
      `;
    }

    buildReturnContent() {
      const returnInfoUrl = 'https://fansbrands.ro/pages/centru-cunostinte-intrebari-frecvente?hcUrl=%2Fen-US%2Farticles%2Finformatii-despre-retur-412661';

      return `
        <div class="fb-pa-body">
          <div class="fb-pa-title"><span class="fb-pa-red">Probează acasă,</span> fără riscuri</div>
          <div class="fb-pa-steps">
            <div class="fb-pa-step"><span class="fb-pa-step__number">1.</span><span>Solicită returul în termen de 180 de zile.</span></div>
            <div class="fb-pa-step"><span class="fb-pa-step__number">2.</span><span>Produsul trebuie să fie în stare originală, nefolosit.</span></div>
            <div class="fb-pa-step"><span class="fb-pa-step__number">3.</span><span>Trimite produsul înapoi, iar noi îți rambursăm contravaloarea.</span></div>
          </div>
          <a class="fb-pa-safe" href="${returnInfoUrl}">
            <span class="fb-pa-safe__icon" aria-hidden="true">
              <svg viewBox="0 0 32 32" fill="none">
                <path d="M16 3.5 26 7.2v7.7c0 6.6-3.8 11.2-10 14-6.2-2.8-10-7.4-10-14V7.2L16 3.5Z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/>
                <polyline points="10.8,16.2 14.2,19.6 21.4,12.4" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <strong>Retur simplu și sigur</strong>
          </a>
        </div>
      `;
    }

    buildPremiumAccordions() {
      const postCart = this.content?.querySelector('[data-fb-quick-post-cart]');
      if (!postCart) return;

      postCart.innerHTML = '';
      postCart.appendChild(this.makeAccordion({
        key: 'vip',
        className: 'fb-ux-accordion--vip',
        title: 'MEMBRU V.I.P.',
        icon: 'vip',
        html: this.buildVipContent()
      }));
      postCart.appendChild(this.makeAccordion({
        key: 'free-shipping',
        title: 'LIVRARE GRATUITĂ',
        icon: 'truck',
        html: this.buildFreeShippingContent()
      }));
      postCart.appendChild(this.makeAccordion({
        key: 'returns',
        title: 'RETUR ÎN 180 DE ZILE',
        icon: 'return',
        html: this.buildReturnContent()
      }));

      this.syncAccordionData();
    }

    syncAccordionData() {
      const source = this.content?.querySelector('[data-fb-vip-join-price], [data-fb-vip-price]');
      const target = this.content?.querySelector('[data-fb-quick-vip-price]');
      if (source && target) {
        target.textContent = source.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    handleDrawerToggle(event) {
      const opened = event.target;
      if (!opened.matches?.('[data-fb-quick-accordion]') || !opened.open) return;

      this.content?.querySelectorAll('[data-fb-quick-accordion][open]').forEach((accordion) => {
        if (accordion !== opened) accordion.open = false;
      });
    }

    /* ==========================================================
       COPIERE CUPON – COMPLETARE AUTOMATĂ ÎN COȘ
       ========================================================== */

    fbFallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      document.body.removeChild(textarea);
      return copied;
    }

    rememberCouponForCart(code) {
      try {
        window.localStorage.setItem(
          'fb_pending_cart_coupon',
          JSON.stringify({ code, savedAt: Date.now() })
        );
        return true;
      } catch (error) {
        return false;
      }
    }

    fbShowCouponCopied(button) {
      const wrap = button.closest('[data-fb-coupon-wrap]');
      const label = button.querySelector('[data-fb-copy-label]');
      const status = wrap?.querySelector('[data-fb-copy-status]') || null;
      let originalLabel = button.getAttribute('data-fb-original-label');

      if (!originalLabel && label) {
        originalLabel = label.textContent;
        button.setAttribute('data-fb-original-label', originalLabel);
      }

      if (label) label.textContent = 'COPIAT ✓';
      if (status) {
        status.textContent = 'Codul promoțional va fi completat automat în coș.';
        status.hidden = false;
      }

      window.setTimeout(() => {
        if (label) label.textContent = originalLabel || 'COPIAZĂ';
        if (status) {
          status.hidden = true;
          status.textContent = '';
        }
      }, 2200);
    }

    fbShowCouponCopyError(button, code) {
      const wrap = button.closest('[data-fb-coupon-wrap]');
      const status = wrap?.querySelector('[data-fb-copy-status]') || null;
      if (status) {
        status.textContent = 'Codul nu a putut fi copiat automat. Cod promoțional: ' + code;
        status.hidden = false;
      }
    }

    handleCouponCopyClick(event) {
      const button = event.target.closest('quick-add-drawer [data-fb-copy-coupon]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const code = button.getAttribute('data-coupon-code');
      if (!code) return;

      this.rememberCouponForCart(code);

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code)
          .then(() => this.fbShowCouponCopied(button, code))
          .catch(() => {
            if (this.fbFallbackCopy(code)) this.fbShowCouponCopied(button, code);
            else this.fbShowCouponCopyError(button, code);
          });
      } else if (this.fbFallbackCopy(code)) {
        this.fbShowCouponCopied(button, code);
      } else {
        this.fbShowCouponCopyError(button, code);
      }
    }

    /* ==========================================================
       V.I.P. KLAVIYO POPUP
       ========================================================== */

    ensureVipPopup() {
      if (document.querySelector('[data-fb-vip-popup]')) return;
      this.injectVipPopupStyles();

      const popup = document.createElement('div');
      popup.id = 'fb-vip-popup';
      popup.className = 'fb-vip-popup';
      popup.setAttribute('data-fb-vip-popup', '');
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-modal', 'true');
      popup.setAttribute('aria-labelledby', 'fb-vip-popup-title');
      popup.hidden = true;
      popup.innerHTML = `
        <div class="fb-vip-popup__backdrop" data-fb-vip-popup-close></div>
        <div class="fb-vip-popup__dialog" role="document">
          <button type="button" class="fb-vip-popup__close" data-fb-vip-popup-close aria-label="Închide">×</button>
          <div class="fb-vip-popup__content">
            <span id="fb-vip-popup-title" class="visually-hidden">FansBRANDS® V.I.P.</span>
            <div class="klaviyo-form-UFC2vD"></div>
          </div>
        </div>
      `;
      document.body.appendChild(popup);
    }

    injectVipPopupStyles() {
      if (document.getElementById('fb-quick-add-vip-popup-styles')) return;
      const style = document.createElement('style');
      style.id = 'fb-quick-add-vip-popup-styles';
      style.textContent = `
        .fb-vip-popup[hidden] { display: none !important; }
        .fb-vip-popup { position: fixed; inset: 0; z-index: 999999; display: flex; align-items: center; justify-content: center; padding: 20px; }
        .fb-vip-popup__backdrop { position: absolute; inset: 0; background: rgba(0,0,0,.58); }
        .fb-vip-popup__dialog { position: relative; z-index: 1; width: min(980px, calc(100% - 40px)); max-height: calc(100vh - 40px); overflow-y: auto; overflow-x: hidden; background: #fff; border-radius: 12px; padding: 16px; box-sizing: border-box; }
        .fb-vip-popup__content, .fb-vip-popup__content .klaviyo-form-UFC2vD { width: 100%; min-width: 0; }
        .fb-vip-popup__content .klaviyo-form-UFC2vD > div, .fb-vip-popup__content .klaviyo-form-UFC2vD form, .fb-vip-popup__content .klaviyo-form-UFC2vD [role="form"] { width: 100% !important; max-width: none !important; }
        .fb-vip-popup__content img { max-width: 100%; height: auto; }
        .fb-vip-popup__close { position: absolute; top: 8px; right: 12px; z-index: 20; width: 44px; height: 44px; padding: 0; border: 0; background: transparent; color: #111; font-size: 32px; line-height: 1; cursor: pointer; }
        body.fb-vip-popup-open { overflow: hidden; }
        @media screen and (max-width: 749px) {
          .fb-vip-popup { padding: 12px; }
          .fb-vip-popup__dialog { width: calc(100% - 8px); max-height: calc(100vh - 16px); padding: 8px; border-radius: 10px; }
        }
      `;
      document.head.appendChild(style);
    }

    openVipPopup(trigger) {
      this.ensureVipPopup();
      const popup = document.querySelector('[data-fb-vip-popup]');
      if (!popup) return;

      this.fbVipLastFocusedElement = trigger || document.activeElement;
      popup.hidden = false;
      document.body.classList.add('fb-vip-popup-open');

      const closeButton = popup.querySelector('[data-fb-vip-popup-close]');
      if (closeButton) window.setTimeout(() => closeButton.focus(), 0);
    }

    closeVipPopup() {
      const popup = document.querySelector('[data-fb-vip-popup]');
      if (!popup) return;

      popup.hidden = true;
      document.body.classList.remove('fb-vip-popup-open');

      if (
        this.fbVipLastFocusedElement &&
        typeof this.fbVipLastFocusedElement.focus === 'function'
      ) {
        this.fbVipLastFocusedElement.focus();
      }
    }

    handleVipPopupClick(event) {
      const openTrigger = event.target.closest('[data-fb-vip-popup-open]');
      if (openTrigger) {
        event.preventDefault();
        this.openVipPopup(openTrigger);
        return;
      }

      const closeTrigger = event.target.closest('[data-fb-vip-popup-close]');
      if (closeTrigger) {
        event.preventDefault();
        this.closeVipPopup();
      }
    }

    handleVipPopupKeydown(event) {
      if (event.key !== 'Escape') return;
      const popup = document.querySelector('[data-fb-vip-popup]');
      if (popup && !popup.hidden) this.closeVipPopup();
    }

    bindKlaviyoPopupClose() {
      if (window.fbQuickAddKlaviyoCloseBound) return;
      window.fbQuickAddKlaviyoCloseBound = true;

      window.addEventListener('klaviyoForms', (event) => {
        if (
          event.detail &&
          event.detail.formId === 'UFC2vD' &&
          event.detail.type === 'close'
        ) {
          this.closeVipPopup();
        }
      });
    }

    hasOtherRealVariantChoice() {
      if (!this.productEl) return false;

      const dataset = this.getVariantDataset();

      if (dataset && Array.isArray(dataset.variants) && dataset.variants.length) {
        const optionNames = Array.isArray(dataset.options) ? dataset.options : [];

        for (let index = 0; index < optionNames.length; index += 1) {
          const rawName = typeof optionNames[index] === 'string'
            ? optionNames[index]
            : (optionNames[index]?.name || '');

          const values = new Set();
          const rawValues = [];

          dataset.variants.forEach((variant) => {
            const options = Array.isArray(variant.options)
              ? variant.options
              : [variant.option1, variant.option2, variant.option3];

            const rawValue = options[index];
            const normalized = this.normalizeFb(rawValue);

            if (normalized) {
              values.add(normalized);
              rawValues.push(rawValue);
            }
          });

          const optionLooksLikeSize =
            this.looksLikeSizeName(rawName) ||
            (
              rawValues.length > 0 &&
              rawValues.every((value) => this.isLikelySizeValue(value))
            );

          // O singură opțiune reală de mărime nu deschide drawer-ul.
          if (optionLooksLikeSize) continue;

          if (values.size > 1) return true;
        }

        return false;
      }

      // DOM fallback: ha a termékoldalon van nem-méret jellegű,
      // több értéket tartalmazó választó, akkor maradjon a drawer.
      const groups = Array.from(this.productEl.querySelectorAll(
        '.product-options fieldset, .product-options .option-selector, .product-options [data-option-name]'
      ));

      return groups.some((group) => {
        const controls = Array.from(group.querySelectorAll('input[type="radio"], select'));
        if (!controls.length) return false;

        const sample = controls[0];
        if (this.controlIsSize(sample)) return false;

        const values = new Set();

        controls.forEach((control) => {
          if (control.matches('select')) {
            Array.from(control.options || []).forEach((option) => {
              const normalized = this.normalizeFb(option.value || option.textContent);
              if (normalized) values.add(normalized);
            });
          } else {
            const normalized = this.normalizeFb(control.value);
            if (normalized) values.add(normalized);
          }
        });

        return values.size > 1;
      });
    }

    isDirectAddProduct() {
      if (!this.productEl) return false;

      const productForm = this.productEl.querySelector('product-form');
      const variantInput = productForm?.querySelector('input[name="id"]');
      const addButton = productForm?.querySelector('button[name="add"]');

      if (
        !productForm ||
        !variantInput ||
        !String(variantInput.value || '').trim() ||
        !addButton ||
        addButton.disabled
      ) {
        return false;
      }

      const dataset = this.getVariantDataset();

      // Egyetlen valódi variáns = nincs mit kiválasztani.
      if (dataset && Array.isArray(dataset.variants) && dataset.variants.length === 1) {
        return true;
      }

      // Ha variant-picker sincs, de van érvényes hidden variant ID,
      // szintén nincs valódi választás.
      if (!this.productEl.querySelector('variant-picker')) {
        return true;
      }

      // OSFM / OSFA / ONE SIZE / UNI / bármely egyetlen méret:
      // csak akkor direct add, ha más opcióból sincs több valódi választás.
      if (this.hasSingleSizeOption() && !this.hasOtherRealVariantChoice()) {
        return true;
      }

      return false;
    }

    prepareProductElementIds() {
      if (!this.productEl || this.productEl.dataset.fbQuickPrepared === 'true') return;

      const sectionId = this.productEl.dataset.section;
      if (sectionId) {
        this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');
      }

      this.productEl.dataset.fbQuickPrepared = 'true';
    }

    directAddProduct(opener) {
      if (!this.isDirectAddProduct()) return false;

      this.prepareProductElementIds();

      const productForm = this.productEl.querySelector('product-form');
      const sourceVariantInput = productForm?.querySelector('input[name="id"]');
      const sourceAddButton = productForm?.querySelector('button[name="add"]');

      if (
        !productForm ||
        !sourceVariantInput ||
        !String(sourceVariantInput.value || '').trim() ||
        !sourceAddButton ||
        sourceAddButton.disabled
      ) {
        return false;
      }

      // A theme saját product-form komponensét használjuk,
      // így a kosárfrissítés ugyanazon az útvonalon fut,
      // mint a jelenlegi Quick Addnál.
      this.restoreFormToFooter();
      this.form.innerHTML = productForm.innerHTML;
      this.form.init();

      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = sourceVariantInput.value;
        variantInput.removeAttribute('data-fb-awaiting-size-variant-id');
      }

      this.fbSizeSelected = true;

      const addButton = this.form.querySelector('button[name="add"]');
      if (!addButton || addButton.disabled) return false;

      // Közvetlen kosárba – drawer megnyitása nélkül.
      addButton.click();

      if (opener) {
        window.setTimeout(() => {
          opener.removeAttribute('aria-disabled');
        }, 250);
      }

      return true;
    }

    /* ==========================================================
       FUNCȚIONARE DE BAZĂ QUICK ADD
       ========================================================== */

    bindQuickAddButtonMouseEnter(button) {
      if (button.dataset.quickAddListenerAdded) return;
      button.dataset.quickAddListenerAdded = 'true';
      button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
    }

    handleQuickAddButtonMouseEnter(evt) {
      if (this.fetchedUrls.includes(evt.target.dataset.productUrl)) return;

      this.fetch = {
        url: evt.target.dataset.productUrl,
        promise: fetch(evt.target.dataset.productUrl)
      };
      this.fetchedUrls.push(evt.target.dataset.productUrl);
    }

    handleOpenCartClick(evt) {
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    handleDocumentClick(evt) {
      if (!evt.target.matches('.js-quick-add')) return;

      if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.transitionDelay = '200ms';

        this.cartDrawer.close();
        window.setTimeout(() => {
          this.backBtn.hidden = false;
          this.open(evt.target);
          if (overlay) overlay.style.transitionDelay = '';
        }, 200);
      } else {
        this.open(evt.target);
      }
    }

    handleVariantChange(evt) {
      let url = this.productUrl;
      const variantId = evt.detail.variant ? String(evt.detail.variant.id) : null;

      if (evt.detail.variant) {
        const separator = this.productUrl.split('?').length > 1 ? '&' : '?';
        url += `${separator}variant=${evt.detail.variant.id}`;
      }

      this.querySelectorAll('.js-prod-link').forEach((link) => {
        link.href = url;
      });

      this.scheduleQuickAddCroUpdate(variantId);
      this.scheduleQuickAddInventoryDeliveryUpdate(variantId);
    }

    restoreFormToFooter() {
      if (this.form && this.footer && !this.footer.contains(this.form)) {
        this.footer.appendChild(this.form);
      }
    }

    moveFormIntoContent() {
      const slot = this.content?.querySelector('[data-fb-quick-form-slot]');
      if (slot && this.form && !slot.contains(this.form)) slot.appendChild(this.form);
    }

    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');
      if (this.notification) this.notification.hidden = true;

      const requestedUrl = opener.dataset.productUrl;
      const sameProduct =
        this.productUrl &&
        this.productUrl === requestedUrl &&
        this.productEl;

      // Már betöltött, választást nem igénylő termék:
      // közvetlenül kosárba, ablak nélkül.
      if (sameProduct && this.isDirectAddProduct()) {
        if (this.directAddProduct(opener)) return;
      }

      // Már betöltött, valódi választást igénylő termék:
      // marad a jelenlegi drawer működés.
      if (sameProduct) {
        this.fbSizeSelected = this.hasSingleSizeOption();
        this.moveFormIntoContent();
        super.open(opener);
        opener.removeAttribute('aria-disabled');
        this.scheduleQuickAddCroUpdate();
        this.prepareEmptySizeState();

        [0, 80, 220, 500].forEach((delay) => {
          window.setTimeout(() => {
            if (!this.fbSizeSelected) {
              this.resetUnselectedSizeControls();
              this.prepareEmptySizeState();
            }
          }, delay);
        });

        this.scheduleQuickAddInventoryDeliveryUpdate();
        return;
      }

      this.productUrl = requestedUrl;
      this.fbVariantDataset = null;
      this.fbSizeSelected = false;
      this.fbSizeChartSelectionPending = false;

      this.restoreFormToFooter();
      this.cleanupFbSizeCharts();
      this.content.innerHTML = '';

      if (!this.fetch || this.fetch.url !== requestedUrl) {
        this.fetch = {
          url: requestedUrl,
          promise: fetch(requestedUrl)
        };
      }

      let response = null;

      try {
        response = await this.fetch.promise;
      } catch (error) {
        response = null;
      }

      if (response && response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');

        if (this.productEl) {
          /*
           * FONTOS:
           * ezen a ponton a drawer MÉG NINCS megnyitva.
           *
           * OSFM / OSFA / ONE SIZE / UNI / egyvariánsos terméknél
           * ezért nem tud "bekúszni" a Quick Add ablak.
           */
          if (this.isDirectAddProduct()) {
            this.classList.remove('is-loading');
            this.content.classList.remove('drawer__content--out');
            this.footer.classList.remove('drawer__footer--out');

            this.fetch = null;

            if (this.directAddProduct(opener)) return;
          }

          // Csak valódi választás esetén nyitjuk meg a Quick Add drawert.
          this.classList.add('is-loading');
          this.content.classList.add('drawer__content--out');
          this.footer.classList.add('drawer__footer--out');

          super.open(opener);
          this.renderProduct(opener);
        }
      }

      // Hálózati / markup hiba esetén az eredeti fallback marad,
      // így a Quick Add gomb nem lesz használhatatlan.
      if (!this.productEl && (!response || !response.ok)) {
        this.classList.add('is-loading');
        this.content.classList.add('drawer__content--out');
        this.footer.classList.add('drawer__footer--out');
        super.open(opener);
      }

      this.fetch = null;
      opener.removeAttribute('aria-disabled');
    }

    close() {
      this.restoreFormToFooter();
      super.close(() => {
        this.backBtn.hidden = true;
      });
    }

    renderProduct(opener) {
      this.prepareProductElementIds();
      this.fbVariantDataset = null;
      this.fbSizeSelected = false;
      this.fbSizeChartSelectionPending = false;

      const variantPicker = this.productEl.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.dataset.updateUrl = 'false';
        this.selectFirstVariant = variantPicker.dataset.selectFirstVariant === 'true';
      }

      const sizeChartModal = this.productEl.querySelector('[data-modal="size-chart"]');
      if (sizeChartModal) sizeChartModal.remove();

      this.updateContent();
      this.updateForm();
      this.initializeFbSizeCharts();

      const activeMedia = this.productEl.querySelector(
        '.media-viewer__item.is-current-variant'
      );
      if (activeMedia) this.updateMedia(activeMedia.dataset.mediaId);

      if (opener.dataset.selectedColor && this.selectFirstVariant) {
        window.setTimeout(this.setActiveVariant.bind(this, opener), 10);
      }

      this.prepareEmptySizeState();

      [0, 80, 220, 500].forEach((delay) => {
        window.setTimeout(() => {
          if (!this.fbSizeSelected) {
            this.resetUnselectedSizeControls();
            this.prepareEmptySizeState();
          }
        }, delay);
      });

      this.scheduleQuickAddCroUpdate();
      this.scheduleQuickAddInventoryDeliveryUpdate();
    }

    setActiveVariant(opener) {
      const colorOptionBox = this.querySelector(
        `.opt-btn[value="${opener.dataset.selectedColor}"]`
      );

      if (colorOptionBox) {
        colorOptionBox.click();
      } else {
        const colorOptionDropdown = this.querySelector(
          `.custom-select__option[data-value="${opener.dataset.selectedColor}"]`
        );

        if (colorOptionDropdown) {
          const customSelect = colorOptionDropdown.closest('custom-select');
          customSelect.selectOption(colorOptionDropdown);
        }
      }
    }

    updateMedia(mediaId) {
      const img = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!img) return;

      const rawSrc = img.src || img.dataset.src || '';
      if (!rawSrc) return;

      const src = rawSrc.split('&width=')[0];
      const container = this.querySelector('.quick-add-info__media');
      if (!container) return;

      const width = Math.max(1, container.offsetWidth);
      const aspectRatio = img.width && img.height ? img.width / img.height : 1;
      container.innerHTML = `
        <img
          src="${src}&width=${width}"
          srcset="${src}&width=${width}, ${src}&width=${width * 2} 2x"
          width="${width * 2}"
          height="${(width * 2) / aspectRatio}"
          alt="${img.alt || ''}"
        >
      `;
    }

    updateContent() {
      let weightElem = this.getElementHtml('.product-info__weight');
      if (weightElem && weightElem.length > 0) {
        weightElem = `<div class="product-info__weight text-sm mt-2">${weightElem}</div>`;
      }

      this.content.innerHTML = `
        <div class="fb-quick-cro" data-fb-quick-root data-fb-ux-size-selected="${this.hasSingleSizeOption() ? 'true' : 'false'}"${this.hasSingleSizeOption() ? ' data-fb-single-size-option="true"' : ''}>
          <div class="fb-quick-cro__header">
            <div class="fb-quick-cro__title">
              <a class="js-prod-link" href="${this.productUrl}">
                ${this.getElementHtml('.product-title')}
              </a>
            </div>

            <div class="fb-quick-cro__sku product-vendor-sku text-sm">
              ${this.getElementHtml('.product-vendor-sku')}
            </div>

            ${weightElem}
          </div>

          <div class="product-price quick-add-mobile-price fb-quick-cro__price">
            ${this.getElementHtml('.product-price')}
          </div>

          <div class="product-options fb-quick-cro__options">
            ${this.getElementHtml('.product-options', '.custom-option:not(.quick-add-hidden)')}
          </div>

          <div class="fb-quick-add-inventory-delivery" data-fb-quick-add-inventory-delivery aria-live="polite"></div>

          <div class="product-backorder fb-quick-cro__backorder">
            ${this.getElementHtml('.product-backorder')}
          </div>

          <div class="fb-quick-cro__form-slot" data-fb-quick-form-slot></div>

          <div class="fb-ux-post-cart" data-fb-quick-post-cart></div>

          <div class="fb-quick-cro__details-link">
            <a href="${this.productUrl}" class="link js-prod-link">${theme.strings.viewDetails}</a>
          </div>
        </div>
      `;

      this.markSizeOptionGroups();
      this.hideSingleSizeOption();

      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');
    }

    updateForm() {
      const productForm = this.productEl.querySelector('product-form');
      this.footer.classList.remove('quick-add__footer-message');

      if (productForm) {
        this.form.innerHTML = productForm.innerHTML;
        this.form.init();
        this.moveFormIntoContent();
        this.hideSingleSizeOption();
        this.buildPremiumAccordions();
        this.bindCartButtonObserver();
        this.prepareEmptySizeState();
        this.scheduleQuickAddCroUpdate();

        if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      } else {
        const signUpForm = this.productEl.querySelector('.product-signup');
        if (signUpForm) {
          this.form.innerHTML = signUpForm.innerHTML;
          this.moveFormIntoContent();
        } else {
          this.footer.classList.add('quick-add__footer-message');
          this.form.innerHTML = `
            <div class="alert quick-add__alert bg-info-bg text-info-text">
              <div class="flex">
                <div>
                  <svg class="icon icon--price_tag" width="32" height="32" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                    <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                  </svg>
                </div>
                <div>
                  <p class="text-h6 font-bold mb-2">${theme.strings.awaitingSale}</p>
                  <a class="link js-prod-link" href="${this.productUrl}">${theme.strings.viewDetails}</a>
                </div>
              </div>
            </div>
          `;
          this.moveFormIntoContent();
        }
      }

      this.footer.classList.remove('drawer__footer--out');
    }

    getElementHtml(selector, ...additionalSelectors) {
      const selectors = [selector].concat(additionalSelectors);
      let html = '';

      selectors.forEach((sel) => {
        this.productEl.querySelectorAll(sel).forEach((el) => {
          html += el.innerHTML;
        });
      });

      return html;
    }

    addedToCart() {
      if (!this.notification) return;

      window.setTimeout(() => {
        this.notification.hidden = false;
      }, 300);

      window.setTimeout(() => {
        this.notification.hidden = true;
      }, this.notification.dataset.visibleFor);
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}
